const initialState = {
    isPartiallyVerified: JSON.parse(localStorage.getItem('isPartiallyVerified')) || false,
    isFullyVerified: JSON.parse(localStorage.getItem('isFullyVerified')) || false,
  };
  
  // Action Types
  export const SET_PARTIALLY_VERIFIED = "SET_PARTIALLY_VERIFIED";
  export const SET_FULLY_VERIFIED = "SET_FULLY_VERIFIED";
  
  // Action Creators
  export const setPartiallyVerified = () => {
    localStorage.setItem('isPartiallyVerified', true);
    return {
      type: SET_PARTIALLY_VERIFIED,
    };
  };
  
  export const setFullyVerified = () => {
    localStorage.setItem('isFullyVerified', true);
    return {
      type: SET_FULLY_VERIFIED,
    };
  };
  
  // Reducer function
  const verificationReducer = (state = initialState, action) => {
    switch (action.type) {
      case SET_PARTIALLY_VERIFIED:
        return { ...state, isPartiallyVerified: true };
      case SET_FULLY_VERIFIED:
        return { ...state, isFullyVerified: true };
      default:
        return state;
    }
  };
  
  export default verificationReducer;
  